import './sharelist.scss';
import React, { useEffect, useState, useRef, useCallback } from "react";
import { ListGroup, Accordion, Card, Row, Col, Container, Button, Image, ListGroupItem, Dropdown} from "react-bootstrap";
import PropTypes from "prop-types";
import defaultPhoto from "../../images/default.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp, faEllipsisH, faPlus, faChevronLeft, faMapMarkerAlt, faDirections, faLock} from "@fortawesome/free-solid-svg-icons";
import { withRouter, NavLink, Link } from "react-router-dom";
import ApiV2 from "../../common/apiV2"

function SharedUser(props) {
    // const [followingCount, setFollowingCount] = useState(null);
    // const [followerCount, setFollowerCount] = useState(null);
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        const fetchSharedUser = async () => {
        try {
            const user = await ApiV2.getUser(props.share.userId);
            console.log("USER:", user)
            setUserData(user);
            
        } catch (error) {
            // console.log("Unable to fetch following count. Error: ", JSON.stringify(error));
        }
    }
    fetchSharedUser();
    }
        , []
    );

    const getProfilePhoto = (user) =>  {
        if (user.photoURL) {
            return (user.photoURL);
        } else {
            return (defaultPhoto);
        }
    }

    if(userData){
        return(
            <>
                <ListGroup.Item>
                    <Container className="p-0">
                        <Row className="text-center">
                            <Col xs={2} onClick={() => props.history.push(`/user/${props.share.userId}`)}>
                            {/* <Col xs={2}> */}
                                <Image className="profile-photo" src={getProfilePhoto(userData)} roundedCircle />
                            </Col>
                        <Col xs={8} className="p-0" onClick={() => props.history.push(`/user/${props.share.userId}`)}>
                        {/* <Col xs={8} className="p-0"> */}
                            <Row className="justify-content-center">
                                <span className="font-weight-bold friend-name">{userData.firstName.charAt(0).toUpperCase() + userData.firstName.slice(1) + " " + userData.lastName.charAt(0).toUpperCase() + userData.lastName.slice(1)}</span>
                            </Row>
                            <Row className="justify-content-center friend-info">
                                <span className="font-weight-bold">264</span>&nbsp;Followers |&nbsp;<span className="font-weight-bold">233</span>&nbsp;Following</Row>
                            <Row className="justify-content-center friend-info">
                                <span className="font-weight-bold">6</span>&nbsp;Cities |&nbsp;<span className="font-weight-bold">2</span>&nbsp;Places |&nbsp;<span className="font-weight-bold">2</span>&nbsp;Sharelist</Row>
                        </Col>
                        <Col xs={2} className="mb-2 p-0 pr-3 align-self-center">
                            <Row className="justify-content-center">
                            <Dropdown>
                                <Dropdown.Toggle variant="secondary" className="py-0 px-1" id="dropdown-basic">
                                    <small>{props.share.status}</small>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="bg-danger">
                                    <Dropdown.Item className="bg-danger text-light" href="#/action-1"><strong>Cancel</strong></Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                            </Row>
                            {/* <Row className="justify-content-center">
                            <Dropdown>
                                <Button className="py-0 px-1" size="sm"><small>Viewer</small></Button>
                            </Dropdown>
                            </Row> */}
                        </Col>
                        </Row>
                    </Container>
                </ListGroup.Item>
                {/* <ListGroup.Item>
                    <Container className="p-0">
                        <Row className="text-center">
                            <Col xs={2} onClick={() => props.history.push(`/user/${props.share.userId}`)}>
                                <Image className="profile-photo" src={getProfilePhoto(userData)} roundedCircle />
                            </Col>
                        <Col xs={10} className="p-0" onClick={() => props.history.push(`/user/${props.share.userId}`)}>
                            <Row className="justify-content-center">
                                <span className="font-weight-bold friend-name">
                                    {userData.isPublic ? <></> : <FontAwesomeIcon className="mr-1 text-muted" icon={faLock} />}
                                    {userData.firstName.charAt(0).toUpperCase() + userData.firstName.slice(1) + " " + userData.lastName.charAt(0).toUpperCase() + userData.lastName.slice(1)}
                                </span>
                            </Row>
                            <Row className="justify-content-center friend-info">
                                <span className="font-weight-bold">{followerCount}</span>&nbsp;Followers |&nbsp;<span className="font-weight-bold">{followingCount}</span>&nbsp;Following</Row>
                            <Row className="justify-content-center friend-info">
                                <span className="font-weight-bold">{spotMetrics?.citiesCount}</span>&nbsp;Cities |&nbsp;<span className="font-weight-bold">{spotMetrics?.spotCount}</span>&nbsp;Places |&nbsp;<span className="font-weight-bold">{spotMetrics?.collectionCount}</span>&nbsp;Collections</Row>
                        </Col>
                        </Row>
                    </Container>
                </ListGroup.Item> */}
            </>
        )
    } else {
        return(<></>)
    }
    
}

SharedUser.propTypes = {
  share: PropTypes.object.isRequired,
//   userId: PropTypes.string.isRequired
};

export default withRouter(SharedUser);
